<template>
  <ElDialog
    :title="$t('APP.OAUTH.REDIRECT_URLS.NEW_REDIRECT_URL')"
    :visible="value"
    width="20%"
    @close="resetAndClose"
  >
    <ElForm
      :ref="newRedirectUrlFormRef"
      :rules="rules"
      :model="newRedirectUrlFormModel"
      @submit.native.prevent="addRedirectUrl"
    >
      <ElFormItem
        :label="$t('APP.OAUTH.REDIRECT_URLS.SINGLE_REDIRECT_URL')"
        prop="url"
      >
        <ElInput
          v-model="newRedirectUrlFormModel.url"
          type="text"
          name="url"
          dir="ltr"
          required
          :disabled="loading"
        />
      </ElFormItem>
    </ElForm>

    <div slot="footer" class="dialog-footer">
      <ElButton
        type="primary"
        :loading="loading"
        @click.native.prevent="addRedirectUrl"
      >
        {{ $t('APP.OAUTH.REDIRECT_URLS.NEW_REDIRECT_URL') }}
      </ElButton>
      <ElButton type="text" :plain="true" @click.native.prevent="resetAndClose">
        {{ $t('CANCEL') }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script>
import { OAuth } from '@/api/api';
import form from '@/mixins/form';
import required from '@/utils/validation-rules/required';
import packageName from '@/mixins/packageName';

export default {
  name: 'AddRedirectUrlModal',
  mixins: [form, packageName],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newRedirectUrlFormModel: {
        url: '',
      },
      loading: false,
    };
  },
  computed: {
    rules() {
      return {
        url: {
          ...required(this.$t('VALIDATION.URL_IS_INVALID')),
          type: 'url',
        },
      };
    },
    newRedirectUrlFormRef() {
      return 'newRedirectUrlFormRef';
    },
  },
  methods: {
    reset() {
      this.resetForm(this.newRedirectUrlFormRef);
    },
    resetAndClose() {
      this.reset();
      this.$emit('input', false);
    },
    addRedirectUrl() {
      if (!this.isValid(this.newRedirectUrlFormRef)) {
        return;
      }

      this.loading = true;

      return OAuth.addRedirectUrl({
        packageName: this.packageName,
        url: this.newRedirectUrlFormModel.url,
      })
        .then(redirectUrl => {
          this.$message.success(
            this.$t('APP.OAUTH.REDIRECT_URLS.REDIRECT_URL_CREATED'),
          );
          this.$emit('redirect-url-add', { ...redirectUrl });
          this.resetAndClose();
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
